<h1>Fleet Management</h1>
<nz-row [nzGutter]="24">
  <nz-col nzSpan="8" style="text-align: left;">
    <button nz-button nzType="primary" (click)="openNewFleetModal()">Add New Fleet</button>
  </nz-col>
  
  <nz-col nzSpan="8">
    <input nz-input [(ngModel)]="searchTerm" placeholder="Enter Fleet Name or contact number"  style=" margin-bottom: 16px;" />
  </nz-col>
  <nz-col nzSpan="8" style="text-align: right;">
    <!-- <button nz-button nzType="primary" (click)="openMergeFleetModal()" [disabled]="!(selectedForMerge().length >= 2)" nz-tooltip="Select two or more fleets to merge. The first selected fleet should be the main fleet.">Merge Fleets</button> -->
  </nz-col>


</nz-row>

<nz-table #spTable [nzData]="filteredFleets()" [nzFrontPagination]="true" [nzLoading]="isLoading()" [nzPageSize]="10" style="margin-top: 16px;">
  <thead>
    <tr>
      <th>Name</th>
      <th>Phone</th>
      <th>WhatsApp Group</th>
      <th>New Incident Link</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    @for (fleet of spTable.data; track fleet.clientId) {
    <tr>
      <td>
        {{ fleet.clientName }}
      </td>
      <td>{{ fleet.clientTel }}</td>
      <td>
        @if (fleet.whatsappGroupLink) {
          <a [href]="fleet.whatsappGroupLink" target="_blank" rel="noopener noreferrer">{{ fleet.whatsappGroupName }}</a>
        } @else {
          {{ fleet.whatsappGroupName }}
        }
      </td>
      <td>
        <a [href]="getNewIncidentLink(fleet.clientId)" target="_blank" rel="noopener noreferrer">{{ getNewIncidentLink(fleet.clientId) }}</a>
        <button nz-button nzType="link" (click)="copyNewIncidentLink(fleet.clientId)" aria-label="Copy new incident link">
          <nz-icon nzType="copy" nzTheme="outline" />
        </button>
      </td>
      <td style="display: flex; align-items: center; justify-content: flex-end;">
        <button nz-button nzType="primary" (click)="viewDetails(fleet)"><nz-icon nzType="edit" nzTheme="outline" />View/Edit Details</button>
        <button nz-button nzType="primary" nzDanger style="margin-left:4px" (click)="removeFleetConnection(fleet.clientId)"><nz-icon nzType="delete" nzTheme="outline"></nz-icon> Remove</button>
        <!-- <input type="checkbox" style="margin-left: 16px;" (change)="toggleFleetForMerge(fleet, $event)" [checked]="isSelectedForMerge(fleet.clientId)" /> -->
      </td>
    </tr>
  }
  </tbody>
</nz-table>

<app-fleet-management-edit
  [selectedFleet]="selectedFleet()"
  [isVisible]="isModalVisible()"
  (visibleChange)="isModalVisible.set($event)"
  (fleetSaved)="onFleetSaved($event)"
  (fleetUpdated)="onFleetUpdated($event)"
  [additionalFleets]="selectedForMerge().slice(1)"
  (fleetsMerged)="onFleetsMerged($event)">
</app-fleet-management-edit>
